import * as React from "react";

function UploadCloud(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" {...props}>
      <path
        d="M38.7 20.08C37.34 13.18 31.28 8 24 8c-5.78 0-10.8 3.28-13.3 8.08C4.68 16.72 0 21.82 0 28c0 6.62 5.38 12 12 12h26c5.52 0 10-4.48 10-10 0-5.28-4.1-9.56-9.3-9.92zM38 36H12c-4.42 0-8-3.58-8-8 0-4.1 3.06-7.52 7.12-7.94l2.14-.22 1-1.9C16.16 14.28 19.88 12 24 12c5.24 0 9.76 3.72 10.78 8.86l.6 3 3.06.22C41.56 24.28 44 26.9 44 30c0 3.3-2.7 6-6 6zM16 26h5.1v6h5.8v-6H32l-8-8-8 8z"
        fill="currentColor"
      />
    </svg>
  );
}

export default UploadCloud;
